import { AlertColor } from '@mui/material';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ToastState = {
  open: boolean;
  message: string;
  severity?: AlertColor;
};

type ShowToast = {
  message: string;
  severity?: AlertColor;
};

const initialState: ToastState = {
  open: false,
  message: '',
};

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    show: (state, action: PayloadAction<ShowToast>) => {
      state.open = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity ?? 'info';
    },
    hide: (state) => {
      state.open = false;
    },
  },
});

export const toastActions = toastSlice.actions;
export const toastReducer = toastSlice.reducer;
